var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/CommonHonoredList/CommonHonoredListInner.jinja"] = require( "front/components/CommonHonoredList/CommonHonoredListInner.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/CommonHonoredList/CommonHonoredList.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/CommonHonoredList/CommonHonoredList.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/CommonHonoredList/CommonHonoredListInner.jinja", false, "assets/app/front/components/CommonHonoredList/CommonHonoredList.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "CommonHonoredListInner")) {
var t_7 = t_4.CommonHonoredListInner;
} else {
cb(new Error("cannot import 'CommonHonoredListInner'")); return;
}
context.setVariable("CommonHonoredListInner", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data", "isPopup"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("isPopup", Object.prototype.hasOwnProperty.call(kwargs, "isPopup") ? kwargs["isPopup"] : false);var t_9 = "";t_9 += "\n    <div class=\"CommonHonoredList ";
if(runtime.contextOrFrameLookup(context, frame, "isPopup")) {
t_9 += "CommonHonoredList--popup";
;
}
t_9 += "\">\n        <div class=\"CommonHonoredList-wrapper\">\n            <h2>";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
t_9 += "</h2>\n\n            <div class=\"CommonHonoredList-items\">\n                ";
t_9 += runtime.suppressValue((lineno = 10, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonHonoredListInner"), "CommonHonoredListInner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list"),"isInitial": 1})])), env.opts.autoescape);
t_9 += "\n            </div>\n\n        </div>\n\n        <div ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"hasMore")) {
t_9 += "style=\"display:none\"";
;
}
t_9 += " class=\"CommonHonoredList-showMoreButton\" data-category=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"category"), env.opts.autoescape);
t_9 += "\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")) {
t_9 += " data-id=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id"), env.opts.autoescape);
t_9 += "\"";
;
}
t_9 += ">\n            <button>Show More</button>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("CommonHonoredList");
context.setVariable("CommonHonoredList", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/CommonHonoredList/CommonHonoredList.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonHonoredList/CommonHonoredList.jinja
// module id = 80
// module chunks = 0